import { Component } from '@angular/core';

@Component({
  selector: 'app-administration-reports',
  templateUrl: './administration-reports.component.html',
  styleUrls: ['./administration-reports.component.scss'],
  standalone: false,
})
export class AdministrationReportsComponent {}
